export const USER_DOCUMENT_HEADERS = [
  {
    key: 'name',
    label: 'File name',
    type: 'string',
  },
  {
    key: 'url',
    label: 'View',
    type: 'url',
  },
  {
    key: 'updatedAt',
    label: 'Updated date',
    type: 'date',
  },
  {
    key: 'uploader',
    label: 'Uploaded by',
    type: 'string',
  },
  {
    key: 'comment',
    label: 'Internal comment',
    type: 'input',
  },
  {
    key: 'status',
    label: 'Actions/Status',
    type: 'actions',
  },
]
